window.addEventListener("load", function(evt) {
    //********************************************
    //  Dataprivacy for search
    //********************************************
    document.querySelectorAll('span.cse-button').forEach(function(button) {
        button.addEventListener('click', function() {
            let inputElement = document.querySelector("input[name='q']");
            let inputValue = inputElement ? inputElement.value : '';

            if (inputValue !== '') {
                let searchBox = document.getElementById('cse-search-box');
                let action = searchBox ? searchBox.getAttribute('action') : '';

                if (action) {
                    if (action.indexOf('?') > -1) {
                        action += '&';
                    } else {
                        action += '?';
                    }
                    window.open(action + 'q=' + encodeURIComponent(inputValue));
                }
            } else {
                let label = inputElement ? inputElement.nextElementSibling : null;
                if (label && label.tagName.toLowerCase() === 'label') {
                    label.style.color = 'red';
                }
            }
        });
    });
    //********************************************
    //MobileNavigation LanguageSwitch
    //********************************************
    //document.getElementById("sprache_MLinkDeu").setAttribute("href", document.getElementById("sprache_LinkDeuIDOption").getAttribute("href"));
    //document.getElementById("sprache_MLinkEng").setAttribute("href", document.getElementById("sprache_LinkEngIDOption").getAttribute("href"));


    //********************************************
    // Social Sharing auf Detailseiten
    //********************************************
    // Erstellen eines neuen div-Elements
    var buttonHolder = document.createElement('div');
    buttonHolder.className = 'button-holder';
    // Finden des Elements, an das wir den button-holder anhängen wollen
    var detailPartBasic = document.querySelector('#detail .part-basic');
    if(detailPartBasic){
        // Anhängen des button-holders an das gefundene Element
        detailPartBasic.appendChild(buttonHolder);
        // Finden des Elements mit der Klasse 'part-shariff'
        var partShariff = document.querySelector('.part-shariff');
        // Verschieben des part-shariff Elements in den button-holder
        if (partShariff) {
            buttonHolder.appendChild(partShariff);
        }
    }
    //********************************************
    // Slickslider
    //********************************************      
    //insymaScripts._initSlickSliders();

    //********************************************
    // Formulare
    //********************************************  
    //Form styling for Bootstrap 
    insymaScripts._setBootstrapFormStyles();
    insymaScripts._setPageNavActiveState();
    
    //********************************************
    // LINK TO TOP with SMOOTHSCROLL
    //******************************************** 
    insymaScripts._goToTop();

    //********************************************
    // Bootstrap Popper enable
    //******************************************** 
    var popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'))
        var popoverList = popoverTriggerList.map(function (popoverTriggerEl) {
        return new bootstrap.Popover(popoverTriggerEl)
    })

    //********************************************
    // Video Handling
    //********************************************  
    //HTML5 Video Stuff
    insymaVideo.createHTML5Video();
    //Vimeo
    //insymaVideo.initVimeoVideos();
    //Youtube
    //insymaVideo.initYoutubeVideos();
    //********************************************
    // Fancybox Init
    //********************************************
    Fancybox.bind("[data-fancybox]", {
        Thumbs: false,
        dragToClose: false,
        Images: {
            zoom: false,
        },
        Toolbar: {
            display: {
              left: ["infobar"],
              middle: [],
              //right: ["slideshow", "download", "thumbs", "close"],
              right: ["close"],
            },
          },
    });
    Fancybox.bind("[data-gallery]", {
        Thumbs: true,
        dragToClose: false,
        Images: {
            zoom: false,
        },
        Toolbar: {
            display: {
              left: ["infobar"],
              middle: [],
              right: ["slideshow", "close", "thumbs"],
            },
          },
    });
    
    //Bewegung
    
    const els = document.querySelectorAll(".reveal");
    const io = new IntersectionObserver((entries, obs) => {
    
        for (const e of entries) {
            if (e.isIntersecting) {
                e.target.classList.add("is-inview");
                console.log("added is-inview:", e.target.className);
                obs.unobserve(e.target); // nur einmal animieren
            }
        }
      }, {
            threshold: 0.15,              // ab 15% Sichtbarkeit
            rootMargin: "0px 0px -10% 0px" // etwas früher triggern
      });
      els.forEach(el => io.observe(el));
    });
    


//********************************************
// Get URL parameter
// Use: urlParams["preview"]
//********************************************  
var urlParams = {};
(function () {
    var e,
        a = /\+/g,
        r = /([^&=]+)=?([^&]*)/g,
        d = function (s) { return decodeURIComponent(s.replace(a, " ").toLowerCase()); },
        q = window.location.search.substring(1);
    while (e = r.exec(q))
        urlParams[d(e[1])] = d(e[2]);
})();

//Web Stuff
var insymaScripts = {
    //********************************************
    // Set active URL class in preview and live
    // Used in: control_javascript_end.ascx
    //********************************************
    _setActiveUrl: function () {
        var currentPageIdEl = document.getElementById("current_page_id");
        var pagePathIdsEl = document.getElementById("page_path_ids");
        if (!currentPageIdEl || !pagePathIdsEl) {
            return;
        }
        var curent_page_id = currentPageIdEl.value;
        var page_path_ids = pagePathIdsEl.value;
        if (typeof (curent_page_id) != "undefined") {
            document.querySelectorAll("a[data-page-id='" + curent_page_id + "']").forEach(function (element) {

                element.classList.add("activeParentPage","active","text-primary");
                let parent = element.closest("li");
                if (parent) {
                    //parent.style.display = "block";
                }
            });
        }
        if (typeof (page_path_ids) != "undefined" && page_path_ids.indexOf("~") > -1) {
            let arr_page_path_ids = page_path_ids.split("~");
            for (let i = 0; i < arr_page_path_ids.length; i++) {
                if (arr_page_path_ids[i] != curent_page_id) {
                    document.querySelectorAll("a[data-page-id='" + arr_page_path_ids[i] + "']").forEach(function (element) {
                        element.classList.add("activeParentPage","active","text-primary");
                    });
                }
            }
        }
    },
    _materialForms: function () {
        document.querySelectorAll('.part-formular').forEach(el => el.classList.add('part-formular-material'));
        document.querySelectorAll('.con-form-data').forEach(el => el.classList.add('material', 'labelsfloating'));
        document.querySelectorAll('.con-form-data.material .divCaptcha').forEach(el => el.closest('li').classList.add('li-captcha'));

        document.querySelectorAll('.con-form-data.material input[type="text"], .con-form-data.material textarea, .con-form-data.material select').forEach(el => {
            el.closest('li').classList.add('transform-label');

            el.addEventListener('focus', function () {
                this.closest('li').classList.add('focused');
            });

            el.addEventListener('blur', function () {
                const li = this.closest('li');
                if (this.value === '') {
                    li.classList.remove('focused');
                }

                setTimeout(() => {
                    if (this.classList.contains('Validate')) {
                        li.classList.add('Validate');
                    } else {
                        li.classList.remove('Validate');
                    }
                }, 10);
            });
        });

        document.querySelectorAll('.con-form-data.material .RadioButton, .con-form-data.material .CheckBox').forEach(el => {
            el.parentElement.classList.add('transform-label', 'transform-label-gap-xl', 'focused');
        });

        document.querySelectorAll('.con-form-data.material select').forEach(el => {
            el.closest('li').classList.add('transform-label', 'transform-label-gap-xl', 'focused');
        });
    },
    _addClassToAll: function (selector, className) {
        document.querySelectorAll(selector).forEach(element => {
            element.classList.add(className.split(' '));
        });
    },
    _updateViewport: function (scalable) {
        document.querySelector('head meta[name="viewport"]')?.remove();
        const meta = document.createElement('meta');
        meta.name = 'viewport';
        meta.content = `width=device-width, initial-scale=1.0, user-scalable=${scalable ? '1' : '0'}`;
        document.head.prepend(meta);
    },
    _setBootstrapFormStyles: function(){
        // RadioButton Elemente
        this._addClassToAll(".RadioButton li", "form-check me-4 mt-1");
        this._addClassToAll(".RadioButton input", "form-check-input");
        this._addClassToAll(".RadioButton label", "form-check-label");

        // CheckBox Elemente
        this._addClassToAll(".CheckBox li", "form-check me-4 mt-1");
        this._addClassToAll(".CheckBox input", "form-check-input");
        this._addClassToAll(".CheckBox label", "form-check-label");

        // Submit Buttons innerhalb von p-Tags
        this._addClassToAll("p input[type='submit']", "btn btn-primary mt-4");

        //Disable Zoom for Formfields on IPhone
        // Event-Listener für Fokus und Blur auf Eingabefeldern
        const inputElements = document.querySelectorAll('input[type="text"], textarea, select');
        inputElements.forEach(element => {
            element.addEventListener('focus', () => this._updateViewport(false));
            element.addEventListener('blur', () => this._updateViewport(true));
        });
    },
    _goToTop: function () {
        document.querySelectorAll('.totop').forEach(function (element) {
            element.addEventListener('click', function (event) {
                event.preventDefault();

                let scrollToTop = function () {
                    let position = document.documentElement.scrollTop || document.body.scrollTop;
                    if (position > 0) {
                        window.requestAnimationFrame(scrollToTop);
                        window.scrollTo(0, position - position / 8);
                    }
                };

                scrollToTop();
            });
        });
    },
    _setFAQ: function (aElem) {
        const elem = document.querySelector('.' + aElem);
        const titles = elem.querySelectorAll('h3');
        const content = elem.querySelectorAll('div');

        titles.forEach(title => {
            title.innerHTML = "<span class='ui-accordion-header-icon ui-icon ui-icon-triangle-1-e'></span>" + title.innerHTML;
            title.classList.add("ui-accordion-header", "ui-corner-top", "ui-accordion-header-collapsed", "ui-corner-all", "ui-state-default", "ui-accordion-icons");
        });

        content.forEach(div => {
            div.style.display = 'none';
        });

        titles.forEach(title => {
            title.addEventListener('click', function() {
                const span = this.querySelector('span');
                const nextContent = this.nextElementSibling;

                if (this.classList.contains("ui-accordion-header-active")) {
                    this.classList.remove("ui-accordion-header-active", "ui-state-active");
                    span.classList.remove("ui-icon-triangle-1-s");
                    span.classList.add("ui-icon-triangle-1-e");
                    slideUp(nextContent);
                } else {
                    this.classList.add("ui-accordion-header-active", "ui-state-active");
                    span.classList.add("ui-icon-triangle-1-s");
                    span.classList.remove("ui-icon-triangle-1-e");
                    slideDown(nextContent);
                }
            });
        });
    },
    _setTeamPart: function(aElem){
        document.querySelectorAll('.' + aElem + ' input[name="ihf_row"]').forEach(function(input) {
            var _val = "item-count-" + input.value;
            input.nextElementSibling.classList.add(_val);
        });
    },
    _setTabbingPart: function () {
        var tabs = document.querySelectorAll("div.part-tabbing-nav li.tabbing-item");
        var divs = document.querySelectorAll("div.part-tab");

        tabs.forEach((tab, i) => {
            if (i === 0) {
                tab.classList.add("active");
            }
            tab.id = "li_tab_" + i;
        });

        divs.forEach((div, i) => {
            if (i === 0) {
                div.style.display = "block";
            } else {
                div.style.display = "none";
            }
            div.id = "div_tab_" + i;
        });

        tabs.forEach((tab, i) => {
            if (document.querySelector("#div_tab_" + i + " li") === null) {
                tab.style.display = "none";
            }
        });

        tabs.forEach(tab => {
            tab.addEventListener("click", function() {
                if (!this.classList.contains("active")) {
                    var _id = this.id.replace("li", "div");
                    tabs.forEach(t => t.classList.remove("active"));
                    divs.forEach(d => d.style.display = "none");
                    this.classList.add("active");
                    document.getElementById(_id).style.display = "block";
                }
            });
        });

        var lis = document.querySelectorAll("ul.img_thumbs > li");
        var largelis = document.querySelectorAll("ul.img_large > li");

        lis.forEach(li => {
            li.addEventListener("click", function() {
                lis.forEach(l => l.classList.remove("active"));
                this.classList.add("active");
                var _id = this.id;
                largelis.forEach(l => l.style.display = "none");
                document.getElementById(_id.replace("_t_", "_l_")).style.display = "block";
            });
        });
    },
    _bootstrapFormLogicBasic: function () {
        // Selektiere alle Inputs und Textareas, außer bestimmte Typen
        let inputs = document.querySelectorAll('input:not([type="button"]):not([type="submit"]):not([type="hidden"]):not([type="radio"]):not([type="checkbox"]):not([type="range"]):not([type="reset"]), textarea');
        inputs.forEach(function (input) {
            input.classList.add("form-control", "w-100");
            let parentUl = input.closest('ul');
            if (parentUl && parentUl.dataset.float === 'yes') {
                let parentLi = input.closest('li');
                if (parentLi) {
                    parentLi.classList.add("form-floating");
                    let label = parentLi.querySelector('label');
                    if (label) {
                        parentLi.insertBefore(input, label);
                    }
                }
            }
        });
        let selects = document.querySelectorAll('select');
        selects.forEach(function (select) {
            select.classList.add("form-select", "w-100");
            let label = select.previousElementSibling;
            if (label && label.tagName === 'LABEL') {
                select.parentNode.insertBefore(select, label);
            }
            let parentUl = select.closest('ul');
            if (parentUl && parentUl.dataset.float === 'yes') {
                let parentLi = select.closest('li');
                if (parentLi) {
                    parentLi.classList.add("form-floating");
                    let label = parentLi.querySelector('label');
                    if (label) {
                        parentLi.insertBefore(select, label);
                    }
                }
            }
        });
        document.querySelectorAll(".InLineValidate").forEach(el => el.classList.add("invalid-feedback"));
        document.querySelectorAll(".con-form-data.material > li").forEach(el => el.classList.add("mt-4"));
        document.querySelectorAll(".RadioButton li").forEach(el => el.classList.add("form-check", "me-4", "mt-1"));
        document.querySelectorAll(".RadioButton input").forEach(el => el.classList.add("form-check-input"));
        document.querySelectorAll(".RadioButton label").forEach(el => el.classList.add("form-check-label"));
        document.querySelectorAll(".CheckBox li").forEach(el => el.classList.add("form-check", "me-4", "mt-1"));
        document.querySelectorAll(".CheckBox input").forEach(el => el.classList.add("form-check-input"));
        document.querySelectorAll(".CheckBox label").forEach(el => el.classList.add("form-check-label"));
        document.querySelectorAll("input[type='file']").forEach(el => el.closest("li").classList.remove("form-floating"));
        document.querySelectorAll("p input[type='submit']").forEach(el => el.classList.add("btn", "btn-primary", "mt-4"));
        let divCaptcha = document.querySelector("div.divCaptcha");
        if (divCaptcha) {
            let parentUl = divCaptcha.closest('ul');
            if (parentUl && parentUl.dataset.float === 'yes') {
                divCaptcha.parentElement.classList.add("form-floating", "d-sm-flex", "flex-wrap", "position-relative");
            } else {
                divCaptcha.parentElement.classList.add("d-sm-flex", "flex-wrap", "position-relative");
            }
            let forAttr = divCaptcha.previousElementSibling.getAttribute("for");
            let parent = divCaptcha.parentElement;
            let element = document.getElementById(forAttr);
            if (element) {
                parent.prepend(element);
            }
        }
        // Form validation bootstrap class adding function
        let formInputs = document.querySelectorAll(".con-form-data.material input:not([type='button']):not([type='submit']):not([type='hidden']):not([type='radio']):not([type='checkbox']):not([type='range']):not([type='reset']), .con-form-data.material textarea, .con-form-data.material select");
        formInputs.forEach(function (input) {
            input.addEventListener('blur', function () {
                let self = this;
                setTimeout(function () {
                    if (self.classList.contains("Validate")) {
                        self.classList.add("Validate", "form-control", "w-100", "flex-fill", "flex-shrink-0");
                    } else {
                        self.classList.remove("Validate");
                        self.classList.add("form-control", "w-100", "flex-fill", "flex-shrink-0");
                    }
                }, 0);
            });
        });
    },
    _bootstrapFormLogic: function (aParams) {
        let uri = aParams.uri;
        if (aParams.integration === "inside") {
            let tempDiv = document.createElement('div');
            tempDiv.id = 'formtemptemp';
            tempDiv.style.display = 'none';
            document.body.appendChild(tempDiv);

            fetch(uri)
                .then(response => response.text())
                .then(html => {
                    tempDiv.innerHTML = html;
                    let form = tempDiv.querySelector('form');
                    if (form) {
                        document.querySelector('.' + aParams.elem).appendChild(form);
                        insymaScripts._materialForms();
                        insymaScripts._editFormsAfterLoading(aParams);
                    }
                })
                .catch(error => {
                    console.log("Error: " + error.status + ": " + error.statusText, uri);
                });
        } else {
            let buttons = document.querySelectorAll('.' + aParams.elem + ' > span.button');
            buttons.forEach(button => {
                button.addEventListener('click', function () {
                    fetch(aParams.uri)
                        .then(response => response.text())
                        .then(html => {
                            let fancyboxInstance = Fancybox.show([{
                                src: html,
                                type: 'html',
                            }], {
                                on: {
                                    reveal: (fancybox, slide) => {
                                        insymaScripts._materialForms();
                                        insymaScripts._editFormsAfterLoading(aParams);
                                    }
                                }
                            });
                        })
                        .catch(error => {
                            console.log("Error loading content:", error);
                        });
                });
            });
        }
    },
    _setImageListFancyInit: function(aGal, aElem){
        Fancybox.bind('[data-fancybox="' + aGal + '"]', {
            Images: {
                zoom: false,
            },
              // Your custom options for a specific gallery
        });
    },
    _loadZenContent: function(aId){
        var uri = document.getElementById(aId).getAttribute('data-href');
        new Fancybox(
            [
                {
                    src: uri,
                    type: "ajax",
                    touch: false
                },
            ],
            {
                on: {
                    done: (fancybox, slide) => {
                        insymaScripts._materialForms();
                    }
                }
            }
        )
    },
    _openPromo: function() {
        // Show and toggle class for dialog-promotion
        let dialogPromotion = document.querySelector(".dialog-promotion");
        if (dialogPromotion) {
            dialogPromotion.style.display = "block";
            dialogPromotion.classList.toggle('visible');
        }

        // Add click event listeners to YouTube inline links
        let youtubeLinks = document.querySelectorAll("a[data-type='youtubeinline']");
        youtubeLinks.forEach(function(link) {
            link.addEventListener("click", function(event) {
                event.preventDefault();
                let contentId = this.getAttribute("data-content-id");
                // Hide all YouTube inline links
                youtubeLinks.forEach(function(ytLink) {
                    ytLink.style.display = "none";
                });
                // Show the frame div
                let frameDiv = document.getElementById("frame_div_" + contentId);
                if (frameDiv) {
                    frameDiv.style.display = "block";
                }
                // Set the src attribute of the iframe
                let iframe = document.getElementById("iframe_movie_youtube_" + contentId);
                if (iframe) {
                    let src = iframe.getAttribute("data-src");
                    iframe.setAttribute("src", src);
                }
                // Uncomment the following line if you want to hide card content elements
                // let cardContentElems = document.querySelectorAll(".card-content-elem");
                // cardContentElems.forEach(function(elem) {
                //     let cardBody = elem.querySelector(".card-body");
                //     let cardFooter = elem.querySelector(".card-footer");
                //     if (cardBody) cardBody.style.display = "none";
                //     if (cardFooter) cardFooter.style.display = "none";
                // });
            });
        });
    },
    _setSearchResults: function(aPath, aPrev){
        let path = "";
        if (aPrev === true) {
            path = "..";
        }
        let urlParams = new URLSearchParams(window.location.search);
        let q = urlParams.get("q");
        if (q !== null && q !== "") {
            let qSpan = document.querySelector("span[data-id='q']");
            if (qSpan) {
                qSpan.textContent = "'" + q + "'";
                let parent = qSpan.parentElement;
                if (parent) parent.style.display = "block";
            }

            q = q.toLowerCase();
            let qInput = document.querySelector("input[name='q']");
            if (qInput) qInput.value = q;
        
            let results = document.querySelector("div[data-id='results']");
            let jsonuri = path + aPath + "search.json";
            let cache2 = new Date().getTime();
            jsonuri = jsonuri + "?ajax=" + cache2;

            let json = insymaContentlist._getData(jsonuri);
            if (typeof json.Data === "undefined") return false;

            let htm = "";
            let figure = "";

            for (let i = 0; i < json.Data.length; i++) {
                let object = json.Data[i];
                if (object.Text.toLowerCase().indexOf(q) > -1) {
                    let found = object.Text.toLowerCase().indexOf(q);
                    let template = document.querySelector("template#searchresult");
                    let _htm = template ? template.innerHTML : "";
                    let temp = object.URL_Live_Detail;
                    let img = object.Img;
                    let txt = insymaScripts._SearchTxtString(object.Text, found);
                    txt = insymaScripts._MarkTxtString(txt, q);

                    if (img !== "") {
                        img = aPrev ? img.split("~")[1] : img.split("~")[0];
                    } else {
                        figure = "placeholder";
                    }

                    if (aPrev === true) {
                        temp = object.URL_Prev_Detail;
                    }

                    _htm = _htm.replace("[uri]", temp);
                    _htm = _htm.replace("[img]", "<img src='" + img + "' />");
                    _htm = _htm.replace("[placeholder]", figure);
                    _htm = _htm.replace("[title]", object.Name);
                    _htm = _htm.replace("[txt]", txt);
                    htm += _htm;
                }
            }

            if (results) results.innerHTML = htm;
        } else {
            let noResults = document.querySelector("strong[data-id='no-results']");
            if (noResults) noResults.style.display = "block";
        }
    },
    _SearchTxtString: function(aTxt, aIndex) {
        let ret = "";
        let start = 0;
        let end = 0;

        if (aIndex - 30 > 0) {
            start = aIndex - 30;
        } else {
            start = 0;
        }
        if (aIndex + 30 < aTxt.length) {
            end = aIndex + 30;
        } else {
            end = aTxt.length;
        }
        ret = aTxt.substring(start, end);
        return ret;
    },
    _insertAtIndex: function(str, substring, index) {
        return str.slice(0, index) + substring + str.slice(index);
    },
    _MarkTxtString: function(aTxt, aStr){
        var start = aTxt.toLowerCase().indexOf(aStr.toLowerCase());
        if(start > -1){
            var substring1 = "<span class='bg-primary'>";
            var substring2 = "</span>";
            var newtext = insymaScripts._insertAtIndex(aTxt, substring1, start);
            start = newtext.toLowerCase().indexOf(aStr.toLowerCase());
            newtext = insymaScripts._insertAtIndex(newtext, substring2, start+aStr.length);
            return newtext
        }
        return false;
    },
    _setCounter: function(){
        const counters = document.querySelectorAll(".count-up");

        const options = {
            threshold: 0.5
        };

        const observer = new IntersectionObserver((entries, observer) => {
            entries.forEach(entry => {
                if (!entry.isIntersecting) return;

                const el = entry.target;
                const target = parseInt(el.dataset.target, 10);
                const duration = 1200; // ms
                const startTime = performance.now();

                function animate(currentTime) {
                    const elapsed = currentTime - startTime;
                    const progress = Math.min(elapsed / duration, 1);
                    const value = Math.floor(progress * target);

                    el.textContent = value;

                    if (progress < 1) {
                      requestAnimationFrame(animate);
                    } else {
                      el.textContent = target;
                    }
                }

                requestAnimationFrame(animate);
                observer.unobserve(el); // nur einmal ausführen
            });
        }, options);

        counters.forEach(counter => observer.observe(counter));
    },
    _setPageNavActiveState: function () {
        const nav = document.getElementById("pageNav");
        if (!nav) {
            return;
        }

        const links = Array.from(nav.querySelectorAll("a[href^='#']"));
        if (!links.length) {
            return;
        }

        const sections = links
            .map(link => {
                const targetId = link.getAttribute("href");
                if (!targetId || targetId === "#") {
                    return null;
                }

                const target = document.querySelector(targetId);
                if (!target) {
                    return null;
                }

                link.setAttribute("aria-current", "false");
                return { link, target };
            })
            .filter(Boolean);

        if (!sections.length) {
            return;
        }

        const setActiveLink = activeLink => {
            sections.forEach(({ link }) => {
                const isActive = link === activeLink;
                link.classList.toggle("nav-is-active", isActive);
                link.setAttribute("aria-current", isActive ? "true" : "false");
            });
        };

        const observer = new IntersectionObserver(entries => {
            const visibleEntries = entries
                .filter(entry => entry.isIntersecting)
                .sort((a, b) => b.intersectionRatio - a.intersectionRatio);

            if (!visibleEntries.length) {
                return;
            }

            const activeSection = sections.find(({ target }) => target === visibleEntries[0].target);
            if (activeSection) {
                setActiveLink(activeSection.link);
            }
        }, {
            root: null,
            threshold: [0.2, 0.35, 0.5, 0.65],
            rootMargin: "-20% 0px -55% 0px"
        });

        sections.forEach(({ target }) => observer.observe(target));

        const currentHashLink = sections.find(({ link }) => link.getAttribute("href") === window.location.hash);
        if (currentHashLink) {
            setActiveLink(currentHashLink.link);
        } else {
            setActiveLink(sections[0].link);
        }
    }
    /*_initSlickSliders: function(){
        $(".part-bilder-liste-gross").find(".slides").slick({
            //prevArrow:"<button type='button' style='min-width: 1px; z-index: 1;' class='depr--slick-prev obj-dir-prev position-absolute btn btn-primary p-0 start-0 top-50 translate-middle'><svg style='width: 36px; margin: 0;' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'><title>menu-left</title><path fill='currentcolor' d='M14,7L9,12L14,17V7Z' /></svg></button>",
            //nextArrow:"<button type='button' style='min-width: 1px; z-index: 1;' class='depr--slick-next obj-dir-next position-absolute btn btn-primary p-0 start-100 top-50 translate-middle'><svg style='width: 36px; margin: 0;' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'><title>menu-right</title><path fill='currentcolor' d='M10,17L15,12L10,7V17Z' /></svg></button>",
            dots: true,
            infinite: false,
            speed: 300,
            slidesToShow: 1,
            adaptiveHeight: true
        });
    },
    _flexsliderArrowPosToImage: function (slider) {
        var ul = $(slider).find("ul.flex-direction-nav a");
        var img = $(slider).find("li.flex-active-slide img");
        ul.css({ "top": (img.height() / 2) + "px" });
    },
    ,
    
    _materialFormsCheckOnLoad: function () {
        $(".con-form-data.material").find("input[type=text], textarea").each(function () {
            var $this = $(this);
            if ($(this).val() == "") {
                $(this).closest("li").removeClass("focused");
            } else {
                $(this).closest("li").addClass("focused");
            }
            setTimeout(function () {
                if ($this.hasClass("Validate")) {
                    $this.closest("li").addClass("Validate");
                } else {
                    $this.closest("li").removeClass("Validate");
                }
            }, 10);
        });
    },
    setParts: function (aId, aPart) {
        if (aPart == "basic") {

            var div = $("#" + aId);
            div.find(".action-content-less").hide();
            div.find(".action-content-more").click(function () {
                $this = $(this);
                $this.hide();
                $this.next().show();
                div.find(".con-content-more").slideDown();
            });
            div.find(".action-content-less").click(function () {
                $this = $(this);
                $this.hide();
                $this.prev().show();
                div.find(".con-content-more").slideUp();
            });
        }
    },
    _setOverlayForAccept: function (t, global) {
        var content = $(".inhalt .shariff-info");
        Dataprivacy.confirm({
            content: content.clone()
        }, function () {
            window.open(t, "_blank", "width=600,height=460");
        });
    },
    
    
    _bootstrapFormLogicBasic: function(){
        var inputs = $('input, textarea').not(':input[type=button], :input[type=submit], :input[type=hidden], :input[type=radio], :input[type=checkbox], :input[type=range], :input[type=reset]');
        $(inputs).each(function() {
            $(this).addClass("form-control w-100");
            
            var attr = $(this).parents("ul").attr("data-float");
            if (typeof attr !== 'undefined' && attr !== false) {
                if($(this).parents("ul").data("float") == "yes"){
                    $(this).parent("li").addClass("form-floating");
                    $(this).insertBefore( $(this).prev('label') );
                }
            }
        });
        var selects = $('select');
        $(selects).each(function() {
            $(this).addClass("form-select w-100");
            $(this).insertBefore( $(this).prev('label') );
            var attr = $(this).parents("ul").attr("data-float");
            if (typeof attr !== 'undefined' && attr !== false) {
                if($(this).parents("ul").data("float") == "yes"){
                    $(this).parent("li").addClass("form-floating");
                    $(this).insertBefore( $(this).prev('label') );
                }
            }
        });

        $(".InLineValidate").addClass("invalid-feedback");
        $(".con-form-data.material > li").addClass("mt-4");
        $(".RadioButton li").addClass("form-check me-4 mt-1");
        $(".RadioButton input").addClass("form-check-input");
        $(".RadioButton label").addClass("form-check-label");

        $(".CheckBox li").addClass("form-check me-4 mt-1");
        $(".CheckBox input").addClass("form-check-input");
        $(".CheckBox label").addClass("form-check-label");

        $("input:file").closest("li").removeClass("form-floating");
        $("p input:submit").addClass("btn btn-primary mt-4");
        var attr = $("div.divCaptcha").parents("ul").attr("data-float");
        if (typeof attr !== 'undefined' && attr !== false) {
            if($("div.divCaptcha").parents("ul").data("float") == "yes"){
                $("div.divCaptcha").parent().addClass("form-floating d-sm-flex flex-wrap position-relative");
            }
            else
                $("div.divCaptcha").parent().addClass("d-sm-flex flex-wrap position-relative");
        }
        $id=$("div.divCaptcha").prev().attr("for");
        $parent=$("div.divCaptcha").parent();
        $parent.prepend($("#"+ $id));
    

        // form validation bootstrap class adding function - flicker bug still open / SCHM 
        $(".con-form-data.material").find("input, textarea, select").not(':input[type=button], :input[type=submit], :input[type=hidden], :input[type=radio], :input[type=checkbox], :input[type=range], :input[type=reset]').each(function () {
			$(this).on("blur", function () {
				var $this = $(this);
				setTimeout(function () {
					if ($this.hasClass("Validate")) {
						$this.addClass("Validate form-control w-100 flex-fill flex-shrink-0");
//                        $this.closest(".InLineValidate").addClass("d-block");

					} else {
						$this.removeClass("Validate");
						$this.addClass("form-control w-100 flex-fill flex-shrink-0");
					}
				}, 0);
			});
		});
    },
    _bootstrapFormLogic: function(aParams){
        //console.log(aParams)
        var uri = aParams.uri;
        if(aParams.integration == "inside"){
            $("body").append("<div id='formtemptemp'></div>");
            $("#formtemptemp").hide().load(uri, function(responseTxt, statusTxt, xhr){
                if(statusTxt == "success")
                {
                    $("#formtemptemp form").appendTo("." + aParams.elem);
                    insymaScripts._materialForms();
                    insymaScripts._editFormsAfterLoading(aParams);
                }
                if(statusTxt == "error")
                    console.log("Error: " + xhr.status + ": " + xhr.statusText, uri);
            })
        }
        else{
            $("." + aParams.elem).children("span.button").on("click", function(){
                $.fancybox.open({
                    src: aParams.uri,
                    type: "ajax",
                    opts : {
                        afterShow : function( instance, current ) {
                            // $(".fancybox-content").find("select, input").not(".no-uniform").uniform({
                            //     fileDefaultText: 'Noch keine Datei ausgewählt',
                            //     fileBtnText: 'Wählen Sie die Datei',
                            // });
                            insymaScripts._materialForms();
                            insymaScripts._editFormsAfterLoading(aParams);
                        }
                    }
                });
            });
        }
    },
    _editFormsAfterLoading(aParams){
        var inputs = $('input, textarea').not(':input[type=button], :input[type=submit], :input[type=radio], :input[type=checkbox], :input[type=range], :input[type=reset]');
        $(inputs).each(function() {
            $(this).addClass("form-control w-100");
            $(this).insertBefore( $(this).prev('label') );
            $(this).parent("li").addClass("form-floating");
        });
        var selects = $('select');
        $(selects).each(function() {
            $(this).addClass("form-select w-100");
            $(this).insertBefore( $(this).prev('label') );
            $(this).parent("li").addClass("form-floating");
        });
        $(".InLineValidate").addClass("invalid-feedback");
        $(".con-form-data.material > li").addClass("mt-4");
        $(".RadioButton li").addClass("form-check me-4 mt-1");
        $(".RadioButton input").addClass("form-check-input");
        $(".RadioButton label").addClass("form-check-label");

        $(".CheckBox li").addClass("form-check me-4 mt-1");
        $(".CheckBox input").addClass("form-check-input");
        $(".CheckBox label").addClass("form-check-label");

        $("p input:submit").addClass("btn btn-primary mt-4");
        $("div.divCaptcha").parent().addClass("form-floating d-flex");

        $id=$("div.divCaptcha").prev().attr("for");
        $parent=$("div.divCaptcha").parent();
        $parent.prepend($("#"+ $id));
        // form validation bootstrap class adding function - flicker bug still open / SCHM 
        $(".con-form-data.material").find("input, textarea, select").not(':input[type=button], :input[type=submit], :input[type=hidden], :input[type=radio], :input[type=checkbox], :input[type=range], :input[type=reset]').each(function () {
            $(this).on("blur", function () {
                var $this = $(this);
                setTimeout(function () {
                    if ($this.hasClass("Validate")) {
                        $this.addClass("Validate form-control w-100 flex-fill flex-shrink-0");


                    } else {
                        $this.removeClass("Validate");
                        $this.addClass("form-control w-100 flex-fill flex-shrink-0");
                    }
                }, 0);
            });
        });
    },
    _loadZenContent: function(aId){
        var uri = $("#" + aId).data("href");
        $.fancybox.open({
            src: uri,
            type: "ajax",
            opts : {
                afterShow : function( instance, current ) {
                    // $(".fancybox-content").find("select, input").not(".no-uniform").uniform({
                    //     fileDefaultText: 'Noch keine Datei ausgewählt',
                    //     fileBtnText: 'Wählen Sie die Datei',
                    // });
                    insymaScripts._materialForms();
                }
            }
        });
    },
    
    
    _setBGImages: function(){
        $(".bg-img:not('.youtube'):not('.theme-image')").each(function(){
            $this = $(this);
            $this.css({"background-image": "url(" + $this.data("src") + ")"});
            if($this.children("img").length > 0)
            {
                if ($this.children("img").attr("src").indexOf("1px") > -1) {
                    $this.children("img").attr({
                        src: $this.data("src"),
                        loading: "lazy"
                    });
                }
                    
            }
        });
    },
    _isOnScreen: function(aEl){
        var win = jQuery(window);
        var viewport = {
           top : win.scrollTop(),
           left : win.scrollLeft()
        };
        viewport.right = viewport.left + win.width();
        viewport.bottom = viewport.top + win.height();
        //console.log("div[data-tab='data-" + aEl + "']")
        $this = $("div[data-tab='data-" + aEl + "']");
        //console.log($this.length)
        var bounds = $this.offset();
        if(typeof(bounds) != "undefined")
        {
            bounds.right = bounds.left + $this.outerWidth();
            bounds.bottom = bounds.top + $this.outerHeight();
            return (!(viewport.right < bounds.left || viewport.left > bounds.right || viewport.bottom < bounds.top || viewport.top > bounds.bottom));
        }
        return false;
    },
    
    _setFancyAnitSave: function(aGal, aElem){
        var part_div = $("div[data-id='" + aElem + "']");
        var part_a = part_div.find("a.imagelink");
        console.log(typeof($.fancybox))
        if(typeof($.fancybox) != "undefined"){
            part_a.attr("data-fancybox", aGal);
            part_a.unbind("click");
            $("[data-fancybox='" + aGal + "']").fancybox({
                afterLoad: function( instance, slide ) {
                    $(".fancybox-inner").find("img").attr("oncontextmenu", "return false")
                }  
            });
        }
        else{
            setTimeout(function () {
                insymaScripts._setFancyAnitSave(aGal, aElem)
            }, 100);
        }
    }*/
};

//Mobile Stuff
/*var insymaMobile = {
    initNavigation: function () {
        $("<div id='mobileNaviHolder'><div id='mobileNaviHolderScroller'></div></div>").insertBefore("#root");
        $(".con-logo").clone().appendTo("#mobileNaviHolderScroller");
        $(".NavMain-open").insertBefore("#mobileNaviHolder");
        $(".NavMain-close").appendTo("#mobileNaviHolderScroller");

        $("#IDNavMain li a").each(function () {
            var $this = $(this);
            //Navigation has Childs
            if ($this.next("ul").length > 0) {
                var span = $("<span class='mobileOnly icon handler-child open-child'></span>");
                if ($this.next("ul").hasClass("visible")) {
                    span.toggleClass("open-child close-child");
                }
                span.on("click", function () {
                    $(this).toggleClass("open-child close-child");
                    $(this).next("ul").slideToggle();
                });
                $this.addClass("has-child").after(span);
            }
        });
    },
    createNavigation: function () {
        var $MN_open = $("span.NavMain-open"),
            $MN_close = $("span.NavMain-close");

        $MN_open.click(function () {
            $("html").addClass("mobileNavigOpen");
            $(this).removeClass("showMobile");
            $MN_close.addClass("showMobile");
        });
        $MN_close.click(function () {
            $("html").removeClass("mobileNavigOpen");
            $(this).removeClass("showMobile");
            $MN_open.addClass("showMobile");
        });

    },
    positionNavigation: function () {
        var winW = $(window).width();
        if ($("#size-indikator-tablet").is(":visible")) {
            if ($("#mobileNaviHolderScroller").find("#IDNavMain").length == 0) {
                $("#IDNavMain").appendTo("#mobileNaviHolderScroller");
                $("#IDNavService").appendTo("#mobileNaviHolderScroller");
                $(".con-suche").appendTo("#mobileNaviHolderScroller");
                $(".con-sprache").appendTo("#mobileNaviHolderScroller");
            }
        } else {
            if ($(".NavService #IDNavMain").length == 0) {
                $("#IDNavMain").appendTo("nav.NavMain");
                $("#IDNavService").appendTo("nav.NavService");
                $(".con-suche").insertAfter(".NavService");
                $(".con-sprache").insertAfter(".NavService");
            }
        }
    }
}*/



//jQuery Erweiterungen
//-> Flexslider Loader
/*$.fn.flexloader = function (flexslider) {
    var $this = $(this);
    $this.addClass("flexLoading");
    $(window).on("load", function () {
        $this.removeClass("flexLoading");
        flexslider();
    });
};*/

function slideUp(element) {
    element.style.transitionProperty = 'height, margin, padding';
    element.style.transitionDuration = '500ms';
    element.style.height = element.offsetHeight + 'px';
    element.offsetHeight;
    element.style.overflow = 'hidden';
    element.style.height = 0;
    element.style.paddingTop = 0;
    element.style.paddingBottom = 0;
    element.style.marginTop = 0;
    element.style.marginBottom = 0;
    window.setTimeout( () => {
      element.style.display = 'none';
      element.style.removeProperty('height');
      element.style.removeProperty('padding-top');
      element.style.removeProperty('padding-bottom');
      element.style.removeProperty('margin-top');
      element.style.removeProperty('margin-bottom');
      element.style.removeProperty('overflow');
      element.style.removeProperty('transition-duration');
      element.style.removeProperty('transition-property');
    }, 500);
}

function slideDown(element) {
    element.style.removeProperty('display');
    let display = window.getComputedStyle(element).display;
    if (display === 'none') display = 'block';
    element.style.display = display;
    let height = element.offsetHeight;
    element.style.overflow = 'hidden';
    element.style.height = 0;
    element.style.paddingTop = 0;
    element.style.paddingBottom = 0;
    element.style.marginTop = 0;
    element.style.marginBottom = 0;
    element.offsetHeight;
    element.style.transitionProperty = 'height, margin, padding';
    element.style.transitionDuration = '500ms';
    element.style.height = height + 'px';
    element.style.removeProperty('padding-top');
    element.style.removeProperty('padding-bottom');
    element.style.removeProperty('margin-top');
    element.style.removeProperty('margin-bottom');
    window.setTimeout( () => {
      element.style.removeProperty('height');
      element.style.removeProperty('overflow');
      element.style.removeProperty('transition-duration');
      element.style.removeProperty('transition-property');
    }, 500);
}
